module.exports = __webpack_public_path__ + "static/img/ttt-en.62ccfa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/ttt-en.png
// module id = R7J1
// module chunks = 1